import { fg } from '@atlassian/jira-feature-gating';

const JiraAiReadAgentSessionsMainTopLevelAgentRelayProvider = {
	get(): boolean {
		return fg('jira-ai-read-agent-sessions-main-top-level-agent');
	},
};

export default JiraAiReadAgentSessionsMainTopLevelAgentRelayProvider;
